import React from 'react';
import styled from '@emotion/styled';
import Shimmer from 'react-shimmer-effect';

import {
  TemplatePadder,
  Template,
  Header,
  IconBox,
  CategoryAndName,
  InfoRows,
} from './LeaderboardTemplateCard';

const CategoryBlock = styled('div')`
  height: 11px;
  width: 44px;
  border-radius: 4px;
`;

const ExerciseBlock = styled('div')`
  height: 38px;
  width: 140px;
  border-radius: 4px;
`;

const TagBlock = styled('div')`
  height: 22px;
  width: 72px;
  border-radius: 4px;
  margin-bottom: 12px;
`;

const InfoLineBlock = styled('div')`
  height: 12px;
  border-radius: 4px;
  flex: 1;
  margin: 6px 0;

  & + & {
    border-top: 1px solid #f2f2f2;
    padding-top: 6px;
    margin-top: 0;
  }
`;

const LeaderboardTemplateCardShimmer = () => (
  <TemplatePadder>
    <Template>
      <Header noButtonPad>
        <Shimmer><IconBox /></Shimmer>
        <CategoryAndName gap='6px'>
          <Shimmer><CategoryBlock /></Shimmer>
          <Shimmer><ExerciseBlock /></Shimmer>
        </CategoryAndName>
      </Header>
      <Shimmer><TagBlock /></Shimmer>
      <InfoRows>
        <Shimmer><InfoLineBlock /></Shimmer>
        <Shimmer><InfoLineBlock /></Shimmer>
        <Shimmer><InfoLineBlock /></Shimmer>
      </InfoRows>
    </Template>
  </TemplatePadder>
);

export default LeaderboardTemplateCardShimmer;
